// import router from 'vue-router'
import axios from 'axios';
import Vue from 'vue';

const actions = {
    getAll: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/flexworkers', {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments,
                }
            }
          ).then(res => {
            commit('setFlexworkers', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
    get: ({commit}, payload) => {
        const ApiClient = payload.ApiClient;
        const departments = payload.departments;

        return axios.get(process.env.VUE_APP_HOUR_APP_BACKEND + '/api/flexworker/' + payload.flexworker_id, {
                params: {
                    firebaseIdToken: ApiClient.token,
                    departments: departments
                }
            }
          ).then(res => {
            commit('setFlexworker', res.data.data)
            return res
          }).catch((err) => {
            return err
        });
    },
}

export default actions
